import {
   getProfessionList,
   getUnitList,
   getBrandList,
   getTreeCategoryList,
   getInstitutionsList
 } from '@/api/api.js';
 export default {
   //存储数据
   state: {
     professionDatas: [], //职业列表
     unitList: [], //计量单位列表
     brandList: [], //品牌列表
     categoryList: [], //类目列表
     institutionsList: [], //机构列表
   },
   //同步调用方法
   mutations: {
     changeProfession(state, val) {
       state.professionDatas = val;
     },
     changeUnitList(state, val) {
       state.unitList = val;
     },
     changeBrandList(state, val) {
       state.brandList = val;
     },
     changeCategoryList(state, val) {
       state.categoryList = val;
     },
     changeInstitutionsList(state, val) {
       state.institutionsList = val;
     },


   },
   // 异步调用方法
   actions: {
     // 获取职业列表
     async getProfessionList(context) {
       let res = await getProfessionList();
       context.commit('changeProfession', res.data)
     },
     // 获取计量单位列表
     async getUnit(context) {
       let res = await getUnitList();
       context.commit('changeUnitList', res.data)
     },
     // 获取品牌列表
     async getBrand(context) {
       let res = await getBrandList();
       context.commit('changeBrandList', res.data)
     },
     // 获取类目列表
     async getTreeCategory(context) {
       let res = await getTreeCategoryList();
       context.commit('changeCategoryList', res.data)
     },
     // 获取机构列表
     async getInstitutionsList(context, ag_Name) {
       let res = await getInstitutionsList({
         ag_Name
       });
       context.commit('changeInstitutionsList', res.data)
     }
   }
 }



// WEBPACK FOOTER //
// ./src/store/professions.js